import {
  getOperaLogs
} from '@/services/config'
import i18n from '@/lib/language'
const maps = i18n.t('message["1628"]').split(',') // ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
const store = {
  namespaced: true,
  state: {
    // 全部的数据容器
    datas: [],
    // 当前页数
    page: 1,
    // datas数据是否准备就绪
    datasReady: false
  },
  getters: {
    list: (state) => {
      const { datas = [] } = state
      const arr = []
      const objs = {}
      datas.forEach(item => {
        const time = item.addtime * 1000
        const dt = new Date(time)
        const key = dt.toLocaleDateString().replace(/\//g, '-')
        item.time = dt.toLocaleTimeString()
        if (!objs[key]) {
          objs[key] = []
          arr.push({
            date: key,
            day: maps[dt.getDay()],
            child: objs[key]
          })
        }
        objs[key].push(item)
      })
      return arr
    }
  },
  mutations: {
    // 设置数据容器的值
    setDatas (state, datas) {
      state.datas = state.datas.concat(datas)
      // state.datasReady = true
    },
    setDatasReady (state) {
      state.datasReady = true
    },
    setPage (state, page) {
      state.page = state.page + 1
    }
  },
  actions: {
    // 加载默认数据
    async fetchOperaLogDatas ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getOperaLogs()
        .onSuccess((raw) => {
          // commit('setDatas', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    }
  }
}
export default store
